__turbopack_context__.v({
  "avatar": "MemberCardBase-module-scss-module__kjdYNW__avatar",
  "avatarContainer": "MemberCardBase-module-scss-module__kjdYNW__avatarContainer",
  "left": "MemberCardBase-module-scss-module__kjdYNW__left",
  "name": "MemberCardBase-module-scss-module__kjdYNW__name",
  "nameRole": "MemberCardBase-module-scss-module__kjdYNW__nameRole",
  "right": "MemberCardBase-module-scss-module__kjdYNW__right",
  "role": "MemberCardBase-module-scss-module__kjdYNW__role",
  "root": "MemberCardBase-module-scss-module__kjdYNW__root",
  "text": "MemberCardBase-module-scss-module__kjdYNW__text",
  "tlIcon": "MemberCardBase-module-scss-module__kjdYNW__tlIcon",
});
